import React from 'react';
import ActionSheet from '@tencent/dui-mobile/lib/components/ActionSheet';
import {
    InjectorService,
    WidgetService,
} from '@tencent/workbench';
import {
    isDocAttachmentElement,
} from '@src/slide/domain/ui-model/elements/element-judge';
import type { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import type { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { AttachmentSwitcher } from '@src/slide/application/service/attachment-upload/attachment-switcher';
import { getAttachmentShowType } from '@src/slide/domain/ui-model/element-modeles/property/attachment/utils/attachment';
import { CARD_CONFIG, EShowType, ICON_TEXT_CONFIG, PREVIEW_CONFIG, SIMPLE_TEXT_CONFIG } from '@src/slide/domain/ui-model/element-modeles/property/attachment/constants';

interface OptionItem {
    id: EShowType;
    title: string;
}

type Options = Array<OptionItem>;

export interface AttachmentActionSheetProps {
    uiModel: IShapeModel | IPictureModel;
}

export default class AttachmentActionSheet extends React.Component<AttachmentActionSheetProps> {
    private widgetService: WidgetService;

    public constructor(props) {
        super(props);
        this.widgetService = InjectorService.get(WidgetService);
    }

    public handleClick = (id: EShowType) => {
        const { uiModel } = this.props;
        AttachmentSwitcher.switch(uiModel, id);
        this.handleCancel();
    };

    public handleCancel = () => {
        this.widgetService.remove('slide-attachment-action-sheet', 'embed');
    };

    public render(): JSX.Element {
        const options = this.generateOptions();
        const selectedOption = this.getSelectedOption(options);
        return (
            <ActionSheet
                visible={true}
                onClickAction={this.handleClick}
                onCancel={this.handleCancel}
                selectedIds={[selectedOption.id]}
                options={options}
            />
        );
    }

    private getSelectedOption = (menuData: Options): OptionItem => {
        const { uiModel } = this.props;
        const showType = getAttachmentShowType(uiModel);
        return menuData.find(({ id }) => id === showType) || menuData[0];
    };

    private generateOptions = () => {
        const items = [
            SIMPLE_TEXT_CONFIG,
            ICON_TEXT_CONFIG,
            CARD_CONFIG,
        ];
        const { uiModel } = this.props;
        if (isDocAttachmentElement(uiModel)) {
            return items;
        }
        return [
            ...items,
            PREVIEW_CONFIG,
        ];
    };
}

